import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./TransportLogDialog.css";
import { DataGrid } from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
export default function TransportLogDialog(props) {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const { intl, machineList } = props;
  useEffect(() => {
    const columns = getColumns();
    const rowData = getRows();
    setColumns(columns);
    setRows(rowData);
  }, [props.show]);

  const handleChecked = (event, id,env) => {
    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (row.id === id) {
          return { ...row, [env]: !row[env] };
        }
        return row;
      });

      return updatedRows;
    });
  };


  const getColumns = () => {
    const columns = [
      {
        field: "id",
        headerName: intl.formatMessage({
          id: "ce_edit_transportLog_dialog_no",
        }),
        width: 80,
        sortable: false,
      },
      {
        field: "sn",
        headerName: intl.formatMessage({ id: "machine_id" }),
        width: 140,
        sortable: false,
      },
      {
        field: "dev",
        headerName: intl.formatMessage({
          id: "ce_edit_transportLog_dialog_dev_env",
        }),
        width: 120,
        sortable: false,
        renderCell: (params) => (
          <Checkbox
            key={"dev" + params.row.id}
            checked={params.row.dev}
            onChange={(event) => handleChecked(event, params.row.id,"dev")}
          />
        ),
      },
      {
        field: "qastg",
        headerName: intl.formatMessage({
          id: "ce_edit_transportLog_dialog_dev_stag",
        }),
        width: 120,
        sortable: false,
        renderCell: (params) => (
          <Checkbox
            key={"qastg" + params.row.id}
            checked={params.row.qastg}
            onChange={(event) => handleChecked(event, params.row.id,"qastg")}
          />
        ),
      },
    ];
    return columns;
  };
  const getRows = () => {
    let rows = [];
    if (machineList.length !== 0) {
      rows = machineList.map((item, index) => {
        return {
          id: index + 1,
          sn: item.serialNumber,
          dev: item.transferLogInfo.length
            ? item.transferLogInfo.find((item) => item.env === "dev")
                .transferFlag
            : false,
          qastg: item.transferLogInfo.length
            ? item.transferLogInfo.find((item) => item.env === "qastg")
                .transferFlag
            : false,
        };
      });
    }
    return rows;
  };
  return (
    <Modal
      id="ceTransportLogDialog"
      show={props.show}
      onHide={props.handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="content-title">
            <span>
              {intl.formatMessage({ id: "ce_edit_transportLog_dialog_title" })}
            </span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DataGrid
          rows={rows}
          columns={columns}
          hideFooter={true}
          // disable table header menu bar
          disableColumnMenu={true}
          // disable column reorder
          disableColumnReorder={true}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              "&:focus": {
                outline: "none",
              },
              "&:focus-within": {
                outline: "none",
              },
            },
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.handleClose}>
          {intl.formatMessage({ id: "header_close" })}
        </Button>
        <Button variant="primary" onClick={() => props.handleApply(rows)}>
          {intl.formatMessage({ id: "header_apply" })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
